import React, { Component } from "react"
import config from "react-global-configuration"
import LoginLink from "../common/loginLink"
import * as endpoint from "../../constants/Endpoints"
import ReactHtmlParser from "react-html-parser"
import OutsideClickTrigger from "../common/OutsideClickTrigger"
import "../../../helpers/strings"

class ParkingBuyMemberProductModal extends Component {
  render() {
    if (!this.props.isActive) return ""
    const { product, result, carPark } = this.props.item
    const { changeFromBooking = undefined, isAmendment = false } = this.props
    const isLoggedIn = !!this.props.userAccountDetails
    let memberPricePrefix = ""
    let pricePrefix = ""
    let hasExtras = false
    let extrasAmount = 0
    let changeFromprice = 0
    if (changeFromBooking) {
      hasExtras = changeFromBooking.booking?.items?.extras[0]?.offerLines[0]?.amount ? true : false
      if (hasExtras) {
        extrasAmount = changeFromBooking.booking.items.extras[0].offerLines[0].amount
      }
      memberPricePrefix = changeFromBooking ? (result.memberPrice - (changeFromBooking.booking.price - extrasAmount) > 0 ? "+" : "") : null
      pricePrefix = changeFromBooking ? (result.totalPrice - (changeFromBooking.booking.price - extrasAmount) > 0 ? "+" : "") : null
      changeFromprice = changeFromBooking.booking?.price ? (changeFromprice = changeFromBooking.booking.price) : 0
    }

    const textKeys = config.get("textKeys.parkingList.memberProductModal") || {}

    const headline = textKeys.headline || "Book parkering i {carparkName} {productName} til særlig medlemspris"
    const membershipBenefitUspList =
      textKeys.membershipBenefitUspList ||
      '<h6>Bliv gratis medlem og få:</h6><ul class="d-block--sm"><li><svg class="svg-icon svg-icon--checkmark"><use xlink:href="/dist/svg/symbols.svg#svg-checkmark"></use></svg>Parkering i særlige anlæg til en god pris</li><li><svg class="svg-icon svg-icon--checkmark"><use xlink:href="/dist/svg/symbols.svg#svg-checkmark"></use></svg>Alle dine tidligere bookede reservationer samlet ét sted</li><li><svg class="svg-icon svg-icon--checkmark"><use xlink:href="/dist/svg/symbols.svg#svg-checkmark"></use></svg>Gode tilbud fra CPH Parkering direkte på din mail</li><li><svg class="svg-icon svg-icon--checkmark"><use xlink:href="/dist/svg/symbols.svg#svg-checkmark"></use></svg>Hurtigere checkout når du reserverer parkering</li></ul>'
    const loginLink = textKeys.loginLink || "Log ind / opret"
    const reserve = textKeys.reserve || "Reservér"
    const soldOut = textKeys.soldOut || "Udsolgt"
    const savePercentage = textKeys.savePercentage || "Spar {savePercentage}%"
    const nonMemberPrice = textKeys.nonMemberPrice || "Ikke medlem"
    const memberPrice = textKeys.memberPrice || "Pris med CPH Profil"

    return (
      <div className={"overlay overlay--modal overlay--fixed is-active"}>
        <div className="modal modal--parking-product-row-modal">
          <OutsideClickTrigger onOutsideClick={() => this.props.handleBuyMemberProductModalClose()}>
            <React.Fragment>
              <button className="button button--icon js--close-modal" onClick={() => this.props.handleBuyMemberProductModalClose()}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content modal__content--no-padding">
                <div className="modal__content__inner">
                  <div className="modal__top">
                    <header>
                      <div className="modal__headline">
                        <h3 className="headline-md">{headline.formatUnicorn({ carparkName: carPark.name, productName: product.name })}</h3>
                      </div>
                      <span className="anchor-button anchor-button--parking">
                        {savePercentage.formatUnicorn({
                          savePercentage: Math.round(((result.totalPrice - result.memberPrice) * 100) / result.totalPrice),
                        })}
                      </span>
                      <div className="rich-text">{ReactHtmlParser(membershipBenefitUspList)}</div>
                    </header>
                  </div>
                  {!isLoggedIn ? (
                    <div className="modal__bottom">
                      <div className="modal--parking-product-row-modal__member-prices">
                        <div className="modal--parking-product-row-modal__price-and-cta">
                          <div>
                            <h6 className="headline-xxxs">{memberPrice}</h6>
                            <h3>
                              {isAmendment ? memberPricePrefix : ""}
                              {this.props.priceFormatter(
                                isAmendment ? result.memberPrice - (changeFromprice - (hasExtras ? extrasAmount : 0)) : result.memberPrice,
                              )}
                            </h3>
                          </div>
                          <LoginLink
                            setLoginState={this.props.setLoginState}
                            loginurl={endpoint.ACCOUNT_LOGIN(config && config.hosts, config && config.language)}
                            linkClassName={"button button--small button--general"}
                            spanClassName={"text"}
                            linkText={loginLink}
                          />
                        </div>
                        <div>
                          <p>
                            {nonMemberPrice}: {isAmendment ? pricePrefix : ""}
                            {this.props.priceFormatter(
                              isAmendment ? result.totalPrice - (changeFromprice - (hasExtras ? extrasAmount : 0)) : result.totalPrice,
                            )}
                          </p>
                          <p>
                            {!product.isSoldOut ? (
                              <button
                                className="button--text-link"
                                onClick={() =>
                                  this.props.handleBuyMemberProductModalClose(
                                    this.props.handleReservation(
                                      product.id,
                                      this.props.item,
                                      this.props.handleBuyMemberProductCleanup,
                                      this.props.isAmendment,
                                    ),
                                  )
                                }
                              >
                                <span className="text">{reserve || "OK"}</span>
                              </button>
                            ) : (
                              <button className="button button--link is-disabled">
                                <span className="text">{soldOut || "Udsolgt"}</span>
                              </button>
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="modal__bottom">
                      <div className="modal--parking-product-row-modal__member-prices">
                        <div className="modal--parking-product-row-modal__price-and-cta">
                          <div>
                            <h6 className="headline-xxxs">{memberPrice}</h6>
                            <h3>{this.props.priceFormatter(result.memberPrice)}</h3>
                          </div>
                          {!product.isSoldOut ? (
                            <button
                              className="button button--small button--general"
                              onClick={() =>
                                this.props.handleBuyMemberProductModalClose(
                                  this.props.handleReservation(
                                    product.id,
                                    this.props.item,
                                    this.props.handleBuyMemberProductCleanup,
                                    this.props.isAmendment,
                                  ),
                                )
                              }
                            >
                              <span className="text">{reserve || "OK"}</span>
                            </button>
                          ) : (
                            <button className="button button--small button--general is-disabled">
                              <span className="text">{soldOut || "Udsolgt"}</span>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}

export default ParkingBuyMemberProductModal
